<template lang="pug">
.case-container
  .case-content
    .case-case__title
        div(
          style="width:4px;height:80px;background-color: #478bca;"
        )
        .title__content
          span {{ $t('案例分享：泰克科技') }}
          span {{ $t('测试、测量、检测行业全球领导者。') }}
    .case-case__summary
      div(
        style="margin-right: 300px"
      )
        i.iconfont.iconhangye
        span {{ $t('广告主行业：电子电工') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('为TeKtronix提供广点通及微信广告投放服务。 ') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('客户产品专业性比较强，受众比较单一，随着腾讯产品用户的不断增加，客户想抓住商机在腾讯系产品内投放广告，但之前对该类广告没有相关了解，不知如何投放。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content 1）{{ $t('媒体选择上，我们从人群覆盖度上考虑建议客户可以同时选择QQ天气、腾讯新闻以及微信公众号这三个广告位。') }}
        .content 2）{{ $t('人群定向上，我们建议客户可以尝试多种定向如兴趣定向、关键词定向和手机号定向。这三种定向方式既保证了较广的覆盖量同时也保证了人群的精准性。') }}
        .content 3）{{ $t('投放素材上，在定向模式不变的情况下，我们建议客户进行A/B Test选出最优的素材。另外素材形式上建议客户可以不拘泥于传统的图片广告同时也可以投放一些视频广告。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户广告CPC保持稳定，CTR不断上升，每天都有10-20个留资。') }}
  contact
</template>"
<script>
import Contact from '@/components/Contact'
export default {
  components: {
    Contact
  }
}
</script>
